export const lightTheme = {
  // Cores principais
  primary: '#0012ff',
  primaryDark: '#9333EA',
  primaryGradient: 'linear-gradient(90deg, #0012ff 0%, #1f0554 100%)',
  secondary: '#1f0554',
  success: '#52c41a',
  warning: '#faad14',
  error: '#f5222d',
  info: '#1890ff',

  //Menus
  sidebarBackground: '#ffffff',
  menuItemBackground: '#0012ff',
  menuItemSelectedBackground: '#1f0554',
  menuItemSelectedText: '#ffffff',
  menuItemText: '#ffffff',
  menuItemHoverBackground: '#1f0554',
  menuItemHoverText: '#ffffff',
  menuItemActiveBackground: '#1f0554',
  menuItemActiveText: '#ffffff',
  menuItemInactiveBackground: '#ffffff',

  // Cores de fundo
  background: '#F9FAFB',
  backgroundSecondary: '#ffffff',
  backgroundTertiary: '#ffffff',

  // Cores de texto
  textPrimary: '#5C3E91',
  textSecondary: 'rgba(0, 0, 0, 0.65)',
  textTertiary: 'rgba(0, 0, 0, 0.45)',
  black: '#000000',

  // Cores de borda
  border: '#E5E7EB',
  borderSecondary: '#f0f0f0',

  // Cores de hover
  hoverPrimary: '#40a9ff',
  hoverSecondary: '#73d13d',

  // Cores de componentes
  cardBackground: '#ffffff',
  inputBackground: '#ffffff',
  selectBackground: '#ffffff',
  buttonText: '#ffffff',
  linkColor: '#1890ff',

  white: '#ffffff',
  // Cores de status
  successBackground: '#f6ffed',
  warningBackground: '#fffbe6',
  errorBackground: '#fff2f0',
  infoBackground: '#e6f7ff',

  // Cores de sombra
  shadow: 'rgba(0, 0, 0, 0.15)',
  shadowLight: 'rgba(0, 0, 0, 0.05)',
};

export const darkTheme = {
  // Cores principais
  primary: '#0012ff',
  primaryDark: '#9333EA',
  primaryGradient: 'linear-gradient(90deg, #0012ff 0%, #1f0554 100%)',
  secondary: '#1f0554',
  success: '#49aa19',
  warning: '#d89614',
  error: '#d32029',
  info: '#177ddc',

  //Menus
  sidebarBackground: '#18191a',
  menuItemBackground: '#18191a',
  menuItemSelectedBackground: '#1f0554',
  menuItemSelectedText: '#ffffff',
  menuItemText: '#e4e6eb',
  menuItemHoverBackground: '#3a3b3c',
  menuItemHoverText: '#ffffff',
  menuItemActiveBackground: '#1f0554',
  menuItemActiveText: '#ffffff',
  menuItemInactiveBackground: '#18191a',

  // Cores de fundo (Dark Gray - Material Design / Dracula style)
  background: '#18191a', // Fundo principal
  backgroundSecondary: '#242526', // Um pouco mais claro para contraste
  backgroundTertiary: '#3a3b3c', // Elementos terciários

  // Cores de texto
  textPrimary: '#e4e6eb',
  textSecondary: '#b0b3b8',
  textTertiary: '#e4e6eb',

  white: 'rgb(255, 255, 255)',

  // Cores de borda
  border: '#3a3b3c',
  borderSecondary: '#3a3b3c',

  // Cores de hover
  hoverPrimary: '#40a9ff',
  hoverSecondary: '#73d13d',

  // Cores de componentes
  cardBackground: '#242526', // Igual ao backgroundSecondary para consistência
  inputBackground: '#3a3b3c', // Inputs um pouco mais destacados
  selectBackground: '#3a3b3c',
  buttonText: '#e4e6eb',
  linkColor: '#177ddc',

  // Cores de status (Ajustadas para dark mode)
  successBackground: '#162312',
  warningBackground: '#2b2111',
  errorBackground: '#2a1215',
  infoBackground: '#111b26',

  // Cores de sombra
  shadow: 'rgba(0, 0, 0, 0.6)',
  shadowLight: 'rgba(0, 0, 0, 0.3)',
};

export const widgetColors = [
    '#2ECC71', '#27AE60', '#1ABC9C', '#16A085', '#D35400', 
    '#E74C3C', '#C0392B', '#3498DB', '#2980B9', '#34495E', 
    '#2C3E50', '#F1C40F', '#F39C12', '#E67E22', '#9B59B6', 
    '#8E44AD', '#ECF0F1', '#BDC3C7', '#95A5A6', '#7F8C8D'
];

export const getRandomWidgetColor = () => {
  return widgetColors[Math.floor(Math.random() * widgetColors.length)];
}

// Exporta o tema padrão (claro)
export const colors = lightTheme;